import React, { useState } from "react";
import {
  Dialog, AppBar, Toolbar, IconButton, Typography, Slide, Box,
  TextField, InputAdornment, Button, Icon
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { axiosInstance as axios, endpoint } from "../../../../api/axios";
import { useSnackbar } from "notistack";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { useSelector } from "react-redux";



// Transition for dialog
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Yup validation schema
const PinSchema = Yup.object().shape({
    name: Yup.string()
    .required("Nama wajib diisi"),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, "Hanya angka yang diperbolehkan")
    .length(12, "Nomor handphone tidak kurang atau lebih dari 12 angka")
    .required("Nomor handphone wajib diisi"),
  email: Yup.string()
    .required("Email wajib diisi atau isi dengan ('-')"),
  address: Yup.string()
    .required("Alamat wajib diisi atau isi dengan ('-')"),
});

const AddPelanggaDialog = ({ open, handleClose }) => {

 const user = useSelector(
    (state) => state.user.users[state.user.currentUserId]
  );

  const { enqueueSnackbar } = useSnackbar();

  // Handle update button
  const handleButtonAddPelanggan = async (values, { setSubmitting }) => {
    try {
        if (user?.token) {
      await axios.post(endpoint.Customer.AddCustomer, {
        name: values.name,
        mobile: values.mobile,
        email: values.email,
        address: values.address,
      },
      {
        headers: {
          Authorization: `${user.token_type} ${user.token}`,
        },
      });
      enqueueSnackbar("Berhasil Tambah Pelanggan!", { variant: "success" });
      handleClose();
    }
    } catch (error) {
      enqueueSnackbar("Gagal Tambah Pelanggan!", { variant: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography sx={{ ml: 2, flex: 1, textAlign: "center" }} variant="h6">
            Tambah Pelanggan
          </Typography>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Formik
          initialValues={{ name: "", mobile: "", email: "", address: "" }}
          validationSchema={PinSchema}
          onSubmit={handleButtonAddPelanggan}
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="text"
                name="name"
                label="Nama"
                placeholder="Masukkan Nama"
                value={values.name}
                onChange={handleChange}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name && errors.name}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                    
                    </InputAdornment>
                  )
                }}
              />

            <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="mobile"
                name="mobile"
                label="Nomor Handphone"
                placeholder="Nomor Handphone"
                value={values.mobile}
                onChange={handleChange}
                error={touched.mobile && Boolean(errors.mobile)}
                helperText={touched.mobile && errors.mobile}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SmartphoneIcon />
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="email"
                name="email"
                label="Email"
                placeholder="Masukkan Email"
                value={values.email}
                onChange={handleChange}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlinedIcon />
                    </InputAdornment>
                  )
                }}
              />

            <TextField
                fullWidth
                size="small"
                variant="outlined"
                type="textl"
                rows={3}
                name="address"
                label="Alamat"
                placeholder="Masukkan Alamat"
                value={values.address}
                onChange={handleChange}
                error={touched.address && Boolean(errors.address)}
                helperText={touched.address && errors.address}
                sx={{
                  mb: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                    </InputAdornment>
                  )
                }}
              />


              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={isSubmitting}
                sx={{
                  textTransform: "none",
                  bgcolor: "#424242",
                  borderRadius: 5,
                  ":hover": { bgcolor: "#08306b" },
                }}
              >
                {isSubmitting ? "Menyimpan..." : "Simpan"}
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default AddPelanggaDialog;
